import can from '../helpers/can';
import store from '../store';

export default function checkPermissions({next, to, router}) {
    const requiredPermissions = to.meta.permissions;
    store.dispatch('permission/get').then(() => {
        const canEnter = can(requiredPermissions);
        if (canEnter) {
            return next();
        }

        return router.push({name: 'Dashboard'});
    });
}